import {
  algoliaSearch,
  AlgoliaSearchParams,
} from "../../../../api/postCall/algoliaSearch";
import { getBearerToken } from "../../../../api/postCall/bearerToken";
import { AlgoliaSearchResponse } from "../../../../data-model/algoliaSearchModel";
import { AuthStatusOptionModel } from "../../../../data-model/authStatusOptions";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";
import { MyMedicalPaOrdersState } from "../hooks/useMyPaOrdersTableData";
import { generateMyMedicalPaOrdersTableDataFromAlgoliaRecords } from "../utils/generateTableDataFromAlgoliaRecords";

export const makePostCallForMyPaOrders = async (
  payload: AlgoliaSearchParams,
  authStatusOptions: AuthStatusOptionModel[],
  setMyMedicalPaOrdersState: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersState>
  >,
  setTableData: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersTableData[]>
  >,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
) => {
  setMyMedicalPaOrdersState((prev) => ({ ...prev, loading: true }));
  try {
    await getBearerToken();
    const response = await algoliaSearch(payload);
    const data: AlgoliaSearchResponse = JSON.parse(
      response,
    ) as AlgoliaSearchResponse;
    setMyMedicalPaOrdersState((prev) => ({
      ...prev,
      data: data,
    }));
    setTableData(
      generateMyMedicalPaOrdersTableDataFromAlgoliaRecords(
        data.hits ?? [],
        authStatusOptions,
      ),
    );
  } catch (error) {
    setMyMedicalPaOrdersState((prev) => ({ ...prev, error: error as string }));
  } finally {
    setMyMedicalPaOrdersState((prev) => ({ ...prev, loading: false }));
    setPaginationResetCount((prev) => prev + 1);
  }
};
